import { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import VolverAlPanel from '../components/VolverAlPanel';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import './Sensores.css';

function Sensores() {
  const usuario = JSON.parse(localStorage.getItem('usuario'));
  const [sensores, setSensores] = useState([]);
  const [filtros, setFiltros] = useState({
    piscicultura: '',
    tipo: '',
    modelo: ''
  });

  useEffect(() => {
    const token = localStorage.getItem("token");

    fetch('https://iacloud.iapatagonia.cl/backend/sensores', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => {
        if (!res.ok) throw new Error("No autorizado");
        return res.json();
      })
      .then(data => setSensores(data))
      .catch(err => {
        console.error("Error al obtener sensores:", err);
        alert("No tienes permisos para ver esta información.");
      });
  }, []);

  const sensoresFiltrados = sensores.filter(sensor =>
    (!filtros.piscicultura || sensor.Piscicultura === filtros.piscicultura) &&
    (!filtros.tipo || sensor.TipoSensor === filtros.tipo) &&
    (!filtros.modelo || sensor.Modelo === filtros.modelo)
  );

  const pisciculturasUnicas = [...new Set(sensores.map(s => s.Piscicultura))];
  const tiposUnicos = [...new Set(sensores.map(s => s.TipoSensor))];
  const modelosUnicos = [...new Set(sensores.map(s => s.Modelo))];

  const getIconoSensor = (tipo) => {
    switch (tipo.toLowerCase()) {
      case 'oxígeno':
        return '💧';
      case 'temperatura':
        return '🌡️';
      case 'saturación':
        return '🫧';
      case 'ph':
        return '⚗️';
      case 'caudal':
        return '🚰';
      default:
        return '🔧';
    }
  };

  const exportarPDF = (data) => {
    const doc = new jsPDF();
    const logo = `${window.location.origin}/logo.png`;
    const fecha = new Date().toLocaleString('es-CL');

    doc.addImage(logo, 'PNG', 10, 10, 30, 30);
    doc.setFontSize(14);
    doc.text("IAPatagonia Technology", 50, 18);
    doc.setFontSize(11);
    doc.text(`Reporte de Sensores (${data.length})`, 50, 26);
    doc.setFontSize(9);
    doc.text(`Generado el ${fecha}`, 50, 32);

    const headers = [["ID", "Modelo", "Tipo", "Unidad", "Piscicultura", "Empresa"]];
    const rows = data.map(s => [
      s.IdSensor,
      s.Modelo,
      s.TipoSensor,
      s.UnidadMedida,
      s.Piscicultura,
      s.Empresa
    ]);

    autoTable(doc, {
      startY: 45,
      head: headers,
      body: rows,
      styles: { fontSize: 9 },
      headStyles: { fillColor: [3, 27, 46] },
      alternateRowStyles: { fillColor: [240, 250, 255] },
    });

    doc.save("Sensores_IAPatagonia.pdf");
  };

  return (
    <>
      <Navbar nombre={usuario.nombre_completo} rol={usuario.rol} />
      <div className="sensor-page">
        <div className="sensor-container glass-card fadeIn slideUp">
          <h2>📟 Sensores disponibles</h2>
          <p>Filtra y revisa la información de tus sensores conectados.</p>

          <div className="filtros">
            <select value={filtros.piscicultura} onChange={e => setFiltros({ ...filtros, piscicultura: e.target.value })}>
              <option value="">Todas las Pisciculturas</option>
              {pisciculturasUnicas.map(p => <option key={p} value={p}>{p}</option>)}
            </select>

            <select value={filtros.tipo} onChange={e => setFiltros({ ...filtros, tipo: e.target.value })}>
              <option value="">Todos los Tipos</option>
              {tiposUnicos.map(t => <option key={t} value={t}>{t}</option>)}
            </select>

            <select value={filtros.modelo} onChange={e => setFiltros({ ...filtros, modelo: e.target.value })}>
              <option value="">Todos los Modelos</option>
              {modelosUnicos.map(m => <option key={m} value={m}>{m}</option>)}
            </select>
          </div>

         <div className="btn-exportar-wrapper">
            <button className="btn-exportar" onClick={() => exportarPDF(sensoresFiltrados)}>
              📄 Exportar PDF
            </button>
          </div>


          <div className="cards-grid">
            {sensoresFiltrados.map(sensor => (
              <div className="sensor-card" key={sensor.IdSensor}>
                <div className="icono-sensor">{getIconoSensor(sensor.TipoSensor)}</div>
                <div className="info-sensor">
                  <h3>{sensor.Modelo}</h3>
                  <p><strong>ID:</strong> {sensor.IdSensor}</p>
                  <p><strong>Tipo:</strong> {sensor.TipoSensor}</p>
                  <p><strong>Unidad:</strong> {sensor.UnidadMedida}</p>
                  <p><strong>Piscicultura:</strong> {sensor.Piscicultura}</p>
                  <p><strong>Empresa:</strong> {sensor.Empresa}</p>
                </div>
              </div>
            ))}
            {sensoresFiltrados.length === 0 && (
              <p className="sin-resultados">No hay sensores que coincidan con los filtros.</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Sensores;
